import React from "react";
import { Icon } from "@iconify-icon/react";
import { cn } from "utils";
import { DeliveryType } from "types/deliveryType.enum";

const deliverySteps = [
  {
    keys: ["placed"],
    label: "Placed",
    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:time-quarter-pass"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
  {
    keys: ["processing", "paid"],
    label: "Processing",
    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:hourglass"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
  {
    keys: ["shipped"],
    label: "Shipped",
    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:delivered-sent"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
  {
    keys: ["delivered"],
    label: "Delivered",
    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:package-receive"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
];

const pickupSteps = [
  {
    keys: ["placed"],
    label: "Placed",

    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:time-quarter-pass"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
  {
    keys: ["processing", "paid"],
    label: "Ready for Pickup",

    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:hourglass"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
  {
    keys: ["delivered"],
    label: "Completed",
    icon: (isActive = false) => (
      <Icon
        icon={"hugeicons:package-receive"}
        className={cn("text-[#A8A8A8] font-bold stroke-2", {
          "text-primary": isActive,
        })}
        width={16}
      />
    ),
  },
];

const IconWrapper = ({
  children,
  className,
  isActive,
}: {
  children: React.ReactNode;
  className?: string;
  isActive?: boolean;
}) => {
  return (
    <div
      className={cn(
        "bg-border text-white rounded-full w-8 h-8 flex items-center justify-center",
        className,
        { "bg-primary-light": isActive }
      )}>
      {children}
    </div>
  );
};

const LineWithDots = ({ isActive }: { isActive?: boolean }) => {
  return (
    <div className="flex items-center justify-between w-full max-w-3xl mx-auto py-2">
      {/* Left Dot */}
      <div
        className={cn("w-2 h-2 rounded-full bg-primary-foreground", {
          "bg-primary": isActive,
        })}></div>

      {/* Line */}
      <div
        className={cn("flex-1 h-[1px] bg-primary-foreground", {
          "bg-primary": isActive,
        })}></div>

      {/* Right Dot */}
      <div
        className={cn("w-2 h-2 rounded-full bg-primary-foreground", {
          "bg-primary": isActive,
        })}></div>
    </div>
  );
};

const getSteps = (deliveryMethod?: DeliveryType) => {
  if (deliveryMethod === DeliveryType.SELF_DELIVERY) {
    return pickupSteps;
  }
  return deliverySteps;
};

export const OrderStatusTimeline = ({
  status: step = "processing",
  deliveryMethod,
}: {
  status?: string;
  deliveryMethod?: DeliveryType;
}) => {
  const activeStep = step?.toLowerCase();

  const steps = getSteps(deliveryMethod);
  console.log("🚀 ~ deliveryMethod:", deliveryMethod);

  const activeIndex = steps.findIndex((step) => step.keys.includes(activeStep));
  console.log("🚀 ~ activeIndex:", activeIndex);

  const isActiveStep = (index: number) => activeIndex >= index;

  return (
    <div className="flex items-end justify-between w-full gap-x-2 rounded-[10px] px-5 py-8 border-border border">
      {steps.map((step, idx) => {
        const lastIndex = steps.length - 1;

        return (
          <>
            <div className="flex flex-col items-center">
              <IconWrapper isActive={isActiveStep(idx)}>
                {step.icon(isActiveStep(idx))}
              </IconWrapper>
              <span
                className={cn(
                  "text-gray-700 font-medium capitalize whitespace-nowrap",
                  {
                    "text-primary": isActiveStep(idx),
                  }
                )}>
                {step.label}
              </span>
            </div>
            {idx !== lastIndex && <LineWithDots isActive={isActiveStep(idx)} />}
          </>
        );
      })}
    </div>
  );
};
